import { render, staticRenderFns } from "./aSpecialRatesTable.vue?vue&type=template&id=18a5b830&scoped=true"
import script from "./aSpecialRatesTable.vue?vue&type=script&lang=js"
export * from "./aSpecialRatesTable.vue?vue&type=script&lang=js"
import style0 from "./aSpecialRatesTable.vue?vue&type=style&index=0&id=18a5b830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a5b830",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VVirtualScroll})
